import * as React from 'react';
import { Cell } from 'fixed-data-table-2';
import { DataGridColumn } from './DataGrid.Column';
import { getTotal } from './DataGrid.ExcelExport';
import { Res } from 'core/api';

export function createFooter<T>(col: DataGridColumn<T>, data: T[], isLastColumn: boolean) {
	const style: React.CSSProperties = {
		position: 'absolute',
		top: 2,
		left: 4,
		fontSize: '90%'
	};
	const totalLabels = {
		'sum': <span className='font-trans' style={style}>{Res.WA.WA_CUSTOM_QUERY_TOTAL_SUM_LBL()}</span>,
		'avg': <span className='font-trans' style={style}>{Res.WA.WA_CUSTOM_QUERY_TOTAL_AVG_LBL()}</span>,
		'count': <span className='font-trans' style={style}>{Res.WA.WA_CUSTOM_QUERY_TOTAL_COUNT_LBL()}</span>,
	};


	return col.showTotalizeFooter && data.length ?
		<Cell className={'text-right ' + (isLastColumn ? 'last-row-cell' : '')}>
			{totalLabels[col.totalize!]}
			{getTotal(data, col)}
		</Cell>
		: '';
}
